(
    function (skyward, $, undefined)
    {
        var PermissionState =
        {
            FALSE: 0,
            PARTIAL: 1,
            TRUE: 2
        };

        var MenuSecurityItem = function ()
        {
            this.Initialize();
        };
        MenuSecurityItem.prototype = new skyward.observable.Observable();
        MenuSecurityItem.prototype._name = "";
        MenuSecurityItem.prototype.Name = function (value, eventToken)
        {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._name)
                {
                    notify = true;
                }
                this._name = value;
                if (notify)
                {
                    this.notify("Name", eventToken);
                }
            }
            return this._name;
        }
        MenuSecurityItem.prototype._canAllowRead = false;
        MenuSecurityItem.prototype.CanAllowRead = function (value, eventToken)
        {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowRead)
                {
                    notify = true;
                }
                this._canAllowRead = value;
                if (notify)
                {
                    this.notify("CanAllowRead", eventToken);
                }
            }
            return this._canAllowRead;
        }
        MenuSecurityItem.prototype._read = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateRead = function (value)
        {
            if (value == PermissionState.FALSE)
            {
                this.Update(value);
                this.Create(value);
                this.Delete(value);
                this.Delete(value);
                this.MassUpdate(value);
                this.MassCreate(value);
                this.MassDelete(value);
            }
        };
        MenuSecurityItem.prototype.Read = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null)
            {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._read)
                {
                    notify = true;
                }
                this._read = value;
                if (propogate)
                {
                    this.propogateRead(value);
                }
                if (notify)
                {
                    this.notify("Read", eventToken);
                }

            }
            return this.CanAllowRead() ? this._read : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype._canAllowUpdate = false;
        MenuSecurityItem.prototype.CanAllowUpdate = function (value, eventToken)
        {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null)
            {
                var notify = false;
                if (value != this._canAllowUpdate)
                {
                    notify = true;
                }
                this._canAllowUpdate = value;
                if (notify) {
                    this.notify("CanAllowUpdate", eventToken);
                }
            }
            return this._canAllowUpdate;
        }
        MenuSecurityItem.prototype._update = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateUpdate = function (value)
        {
            if (value == PermissionState.TRUE)
            {
                this.Read(value);
            }
        };
        MenuSecurityItem.prototype.Update = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null)
            {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._update)
                {
                    notify = true;
                }
                this._update = value;

                if (propogate)
                {
                    this.propogateUpdate(value);
                }
                if (notify)
                {
                    this.notify("Update", eventToken);
                }

            }
            return this.CanAllowUpdate() ? this._update : PermissionState.FALSE;
        }

        MenuSecurityItem.prototype._canAllowCreate = false;
        MenuSecurityItem.prototype.CanAllowCreate = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowCreate) {
                    notify = true;
                }
                this._canAllowCreate = value;
                if (notify) {
                    this.notify("CanAllowCreate", eventToken);
                }
            }
            return this._canAllowCreate;
        }
        MenuSecurityItem.prototype._create = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateCreate = function (value) {
            if (value == PermissionState.TRUE) {
                this.Update(value);
            }
        }
        MenuSecurityItem.prototype.Create = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._create) {
                    notify = true;
                }
                this._create = value;

                if (propogate)
                    this.propogateCreate(value);

                if (notify) {
                    this.notify("Create", eventToken);
                }

            }
            return this.CanAllowCreate() ? this._create : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype._canAllowDelete = false;
        MenuSecurityItem.prototype.CanAllowDelete = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowDelete) {
                    notify = true;
                }
                this._canAllowDelete = value;
                if (notify) {
                    this.notify("CanAllowDelete", eventToken);
                }
            }
            return this._canAllowDelete;
        }
        MenuSecurityItem.prototype._delete = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateDelete = function (value) {
            if (value == PermissionState.TRUE) {
                this.Create(value);
            }
        };
        MenuSecurityItem.prototype.Delete = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._delete) {
                    notify = true;
                }
                this._delete = value;


                if (propogate)
                    this.propogateDelete(value);

                if (notify) {
                    this.notify("Delete", eventToken);
                }

            }
            return this.CanAllowDelete() ? this._delete : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype._canAllowMassUpdate = false;
        MenuSecurityItem.prototype.CanAllowMassUpdate = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowMassUpdate) {
                    notify = true;
                }
                this._canAllowMassUpdate = value;
                if (notify) {
                    this.notify("CanAllowMassUpdate", eventToken);
                }
            }
            return this._canAllowMassUpdate;
        }
        MenuSecurityItem.prototype._massUpdate = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateMassUpdate = function (value) {
            if (value == PermissionState.TRUE) {
                this.Delete(value);
            }
        };
        MenuSecurityItem.prototype.MassUpdate = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._massUpdate) {
                    notify = true;
                }
                this._massUpdate = value;

                if (propogate)
                    this.propogateMassUpdate(value);
                if (notify) {
                    this.notify("MassUpdate", eventToken);
                }

            }
            return this.CanAllowMassUpdate() ? this._massUpdate : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype._canAllowMassCreate = false;
        MenuSecurityItem.prototype.CanAllowMassCreate = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowMassCreate) {
                    notify = true;
                }
                this._canAllowMassCreate = value;
                if (notify) {
                    this.notify("CanAllowMassCreate", eventToken);
                }
            }
            return this._canAllowMassCreate;
        }
        MenuSecurityItem.prototype._massCreate = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateMassCreate = function (value) {
            if (value == PermissionState.TRUE) {
                this.MassUpdate(value);
            }
        };
        MenuSecurityItem.prototype.MassCreate = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._massCreate) {
                    notify = true;
                }
                this._massCreate = value;


                if (propogate)
                    this.propogateMassCreate(value);

                if (notify) {
                    this.notify("MassCreate", eventToken);
                }

            }
            return this.CanAllowMassCreate() ? this._massCreate : PermissionState.FALSE;
        }
        
        MenuSecurityItem.prototype._canAllowMassDelete = false;
        MenuSecurityItem.prototype.CanAllowMassDelete = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowMassDelete) {
                    notify = true;
                }
                this._canAllowMassDelete = value;
                if (notify) {
                    this.notify("CanAllowMassDelete", eventToken);
                }
            }
            return this._canAllowMassDelete;
        }
        MenuSecurityItem.prototype._massDelete = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateMassDelete = function (value) {
            if (value == PermissionState.TRUE) {
                this.MassCreate(value);
            }
        };
        MenuSecurityItem.prototype.MassDelete = function (value, eventToken, propogate)
        {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null)
            {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._massDelete)
                {
                    notify = true;
                }
                this._massDelete = value;

                if (propogate)
                {
                    this.propogateMassDelete(value);
                }
                if (notify)
                {
                    this.notify("MassDelete", eventToken);
                }

            }
            return this.CanAllowMassDelete() ? this._massDelete : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype.grantsAnyPermission = function ()
        {
            return this.MassDelete() ||
                this.MassCreate() ||
                this.MassUpdate() ||
                this.Delete() ||
                this.Update() ||
                this.Create() ||
                this.Read();
        }


        var MenuSecurityItemGroup = function ()
        {
            this.Initialize();
            this.members = [];
        };
        MenuSecurityItemGroup.prototype = new MenuSecurityItem();
        MenuSecurityItemGroup.prototype.members = [];
        MenuSecurityItemGroup.prototype.UpdateMemberEvent = function (property, member, eventToken)
        {
            var that = this;
            var CreateUpdateMethod = function (property, propertyMethod)
            {
                return function (eventToken)
                {
                    if (!member.eventProcessed(eventToken))
                    {
                        if (property() == PermissionState.FALSE)
                        {
                            propertyMethod(PermissionState.FALSE, eventToken);
                        }
                        else if (property() == PermissionState.TRUE)
                        {
                            propertyMethod(PermissionState.TRUE, eventToken);
                        }
                    }
                }
            };
            switch (property)
            {
                case "Read":
                    return CreateUpdateMethod(function() { return that.Read();}, function (value, eventToken) { return member.Read(value, eventToken, false); });
                case "Update":
                    return CreateUpdateMethod(function () { return that.Update(); }, function (value, eventToken) { return member.Update(value, eventToken, false); });
                case "Create":
                    return CreateUpdateMethod(function () { return that.Create(); }, function (value, eventToken) { return member.Create(value, eventToken, false); });
                case "Delete":
                    return CreateUpdateMethod(function () { return that.Delete(); }, function (value, eventToken) { return member.Delete(value, eventToken, false); });
                case "MassUpdate":
                    return CreateUpdateMethod(function () { return that.MassUpdate(); }, function (value, eventToken) { return member.MassUpdate(value, eventToken, false); });
                case "MassCreate":
                    return CreateUpdateMethod(function () { return that.MassCreate(); }, function (value, eventToken) { return member.MassCreate(value, eventToken, false); });
                case "MassDelete":
                    return CreateUpdateMethod(function () { return that.MassDelete(); }, function (value, eventToken) { return member.MassDelete(value, eventToken, false); });
            }
        }
        MenuSecurityItemGroup.prototype.ApplyRecalculation = function (allTrue, allFalse, propertyApplicator)
        {
            if (allTrue)
            {
                propertyApplicator(PermissionState.TRUE);
            }
            else if (allFalse)
            {
                propertyApplicator(PermissionState.FALSE);
            }
            else
            {
                propertyApplicator(PermissionState.PARTIAL);
            }
        };
        MenuSecurityItemGroup.prototype.GetCollectiveValues = function (members, operation) {
            var total = 0;
            for (var i = 0; i < this.members.length; i++) {
                
                total += operation(this.members[i]);
            }
            return total;
        }
        MenuSecurityItemGroup.prototype.GetNumberOfApplicableMembers = function (members, operation) {
            var total = 0;
            for (var i = 0; i < members.length; i++) {
                total += operation(this.members[i]);
            }
            return total;
        }
        MenuSecurityItemGroup.prototype.RecalculateRead = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowRead(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.CanAllowRead() * member.Read(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) {  that.Read(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateUpdate = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowUpdate(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.CanAllowUpdate() * member.Update(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.Update(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateCreate = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowCreate(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.CanAllowCreate() * member.Create(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.Create(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateDelete = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowDelete(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.Delete(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.Delete(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateMassUpdate = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowMassUpdate(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.MassUpdate(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.MassUpdate(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateMassCreate = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowMassCreate(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.MassCreate(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.MassCreate(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateMassDelete = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowMassDelete(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.MassDelete(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.MassDelete(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.AddMember = function (member) {
            var that = this;
            this.members.push(member);

            var DoBinding = function (memberCanAllow, myCanAllowFunction, recalculateFunction, propertyName) {
                if (memberCanAllow) {
                    myCanAllowFunction(true);
                }

                that.observers[propertyName] = that.observers[propertyName] || [];
                member.observers[propertyName] = member.observers[propertyName] || [];
                that.observers[propertyName].push(that.UpdateMemberEvent(propertyName, member));

                member.observers[propertyName].push(function (eventToken) {
                    if (!that.eventProcessed(eventToken)) {
                        recalculateFunction(eventToken);
                    }
                });
            }

            DoBinding(member.CanAllowRead(), function (value) { return that.CanAllowRead(value); }, function (eventToken) { that.RecalculateRead(eventToken); }, "Read");
            DoBinding(member.CanAllowUpdate(), function (value) { return that.CanAllowUpdate(value); }, function (eventToken) { that.RecalculateUpdate(eventToken); }, "Update");
            DoBinding(member.CanAllowCreate(), function (value) { return that.CanAllowCreate(value); }, function (eventToken) { that.RecalculateCreate(eventToken); }, "Create");
            DoBinding(member.CanAllowDelete(), function (value) { return that.CanAllowDelete(value); }, function (eventToken) { that.RecalculateDelete(eventToken); }, "Delete");
            DoBinding(member.CanAllowMassUpdate(), function (value) { return that.CanAllowMassUpdate(value); }, function (eventToken) { that.RecalculateMassUpdate(eventToken); }, "MassUpdate");
            DoBinding(member.CanAllowMassCreate(), function (value) { return that.CanAllowMassCreate(value); }, function (eventToken) { that.RecalculateMassCreate(eventToken); }, "MassCreate");
            DoBinding(member.CanAllowMassDelete(), function (value) { return that.CanAllowMassDelete(value); }, function (eventToken) { that.RecalculateMassDelete(eventToken); }, "MassDelete");

            this.RecalculateRead(new skyward.observable.Event());
            this.RecalculateUpdate(new skyward.observable.Event());
            this.RecalculateCreate(new skyward.observable.Event());
            this.RecalculateDelete(new skyward.observable.Event());
            this.RecalculateMassUpdate(new skyward.observable.Event());
            this.RecalculateMassCreate(new skyward.observable.Event());
            this.RecalculateMassDelete(new skyward.observable.Event());
        };

        var MenuSecurityViewFactory = function () { };

        var setCheckboxNamesForPost = function (view, menuSecurityID)
        {
            // TODO only set the name on checkboxes that are CanAllow == true.
            var checkboxes = view.find("input.checkbox[data-permission]");
            checkboxes.each(function () {
                var nameValue = "menusecurityitem-" + menuSecurityID + "-" + $(this).attr("data-permission");
                $(this).attr("name", nameValue);
            });
        }

        MenuSecurityViewFactory.prototype.CreateView = function (menuSecurityItemModel, customDisplayFunction, customValueChangedFunction)
        {
            customDisplayFunction = customDisplayFunction || function (view, menuSecurityItemModel)
            {
                var label = view.find(".menuSecurityLabel")[0];
                $(label).text(menuSecurityItemModel.Name());
            };

            var GetMenuSecurityView = function ()
            {
                var result = $("tr.menuSecurityTemplate").first().clone();
                result.removeClass("menuSecurityTemplate");
                return result;
            };

            var SetCheckedStatus = function (checkbox, value)
            {
                checkbox.prop('checked', value);
                checkbox.prop('indeterminate', value == PermissionState.PARTIAL);
            };

            var ToggleModuleSecurityAccessIcon = function (view, model)
            {
                var icon = view.find(".menuSecurityModuleSecurityAccess")
                if (model.grantsAnyPermission() && !icon.hasClass("menuSecurityTemplate"))
                {
                    icon.addClass("granted");
                }
                else
                {
                    icon.removeClass("granted");
                }
            };

            var view = GetMenuSecurityView();

            var bindCheckbox = function (permissionString, canAllowFunction, permissionFunction)
            {
                if (!canAllowFunction())
                {
                    view.find("input.checkbox[data-permission='" + permissionString.toLowerCase() + "']").first().remove();
                }
                else
                {
                    var ucb = view.find("input.checkbox[data-permission='" + permissionString.toLowerCase() + "']").first();
                    SetCheckedStatus(ucb, permissionFunction());

                    // Create the model when the view changes.
                    ucb.change(function (event)
                    {
                        if (this.classList.contains("ui-disabled"))
                        {
                            event.preventDefault();
                            return;
                        }
                        
                        // This is because on IE/Edge, change() happens before click() and the change tracking won't know that the screen is dirty yet.
                        // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6274500/
                        skyward.changeTracking.getChangeTracker(this).overrideDirtyState(true);
                        
                    });
                    ucb.click(function (event)
                    {
                        if (this.classList.contains("ui-disabled"))
                        {
                            event.preventDefault();
                            return;
                        }

                        skyward.changeTracking.getChangeTracker(this).overrideDirtyState(true);
                        var event = new skyward.observable.Event();
                        permissionFunction(ucb.prop("checked") ? PermissionState.TRUE : PermissionState.FALSE, event);
                        ucb.data("events", ucb.data("events") + "," + event.EventID);
                        
                    });
                    
                    // Create the view when the model changes.
                    menuSecurityItemModel.observers[permissionString] = menuSecurityItemModel.observers[permissionString] || [];
                    menuSecurityItemModel.observers[permissionString].push(function (eventToken)
                    {
                        var eventHandled = false;
                        if (ucb.data("events") !== "")
                        {
                            var handledEvents = ucb.data("events").split(",");
                            if (handledEvents.includes(eventToken.EventID))
                            {
                                eventHandled = true;
                            }
                        }

                        if (!eventHandled)
                        {
                            SetCheckedStatus(ucb, permissionFunction());
                            ucb.data("events", ucb.data("events") + "," + eventToken.EventID);

                            ToggleModuleSecurityAccessIcon(view, menuSecurityItemModel);
                            if (customValueChangedFunction)
                            {
                                customValueChangedFunction();
                            }
                        }
                    });
                }
            }
            bindCheckbox('Read', function () { return menuSecurityItemModel.CanAllowRead(); }, function (value, eventToken) { return menuSecurityItemModel.Read(value, eventToken); });
            bindCheckbox('Update', function () { return menuSecurityItemModel.CanAllowUpdate(); }, function (value, eventToken) { return menuSecurityItemModel.Update(value, eventToken); });
            bindCheckbox('Create', function () { return menuSecurityItemModel.CanAllowCreate(); }, function (value, eventToken) { return menuSecurityItemModel.Create(value, eventToken); });
            bindCheckbox('Delete', function () { return menuSecurityItemModel.CanAllowDelete(); }, function (value, eventToken) { return menuSecurityItemModel.Delete(value, eventToken); });
            bindCheckbox('MassUpdate', function () { return menuSecurityItemModel.CanAllowMassUpdate(); }, function (value, eventToken) { return menuSecurityItemModel.MassUpdate(value, eventToken); });
            bindCheckbox('MassCreate', function () { return menuSecurityItemModel.CanAllowMassCreate(); }, function (value, eventToken) { return menuSecurityItemModel.MassCreate(value, eventToken); });
            bindCheckbox('MassDelete', function () { return menuSecurityItemModel.CanAllowMassDelete(); }, function (value, eventToken) { return menuSecurityItemModel.MassDelete(value, eventToken); });
            
            if (!(menuSecurityItemModel instanceof MenuSecurityItemGroup))
            {
                setCheckboxNamesForPost(view, menuSecurityItemModel.MenuSecurityItemID);
            }

            customDisplayFunction(view, menuSecurityItemModel);

            view.attr("data-name", menuSecurityItemModel.Name());
            view.attr("data-menuscreenid", menuSecurityItemModel.MenuScreenID);
            ToggleModuleSecurityAccessIcon(view, menuSecurityItemModel);
            return view;
        };

        skyward.menusecurity = skyward.menusecurity || {};
        skyward.menusecurity.MenuSecurityItem = MenuSecurityItem;
        skyward.menusecurity.MenuSecurityItemGroup = MenuSecurityItemGroup;
        skyward.menusecurity.MenuSecurityViewFactory = MenuSecurityViewFactory;

    }(window.skyward = window.skyward || {}, window.jQuery)
);